import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {


  constructor(
  ) {
  }

  getToken(): string {
    return localStorage.getItem("token");
  }
  setToken(value: string): void {
    localStorage.setItem("token", value);
  }

  getBloqueoGPS(): string {
    return localStorage.getItem("bloqueoGPS");
  }
  setBloqueoGPS(value: string): void {
    localStorage.setItem("bloqueoGPS", value);
  }

  getDesbloqueoGPS(): string {
    return localStorage.getItem("desbloqueoGPS");
  }
  setDesbloqueoGPS(value: string): void {
    localStorage.setItem("desbloqueoGPS", value);
  }

  getUser(): string {
    return localStorage.getItem("user");
  }
  setUser(value: string): void {
    localStorage.setItem("user", value);
  }

  getUserName(): string {
    return localStorage.getItem("userName");
  }
  setUserName(value: string): void {
    localStorage.setItem("userName", value);
  }

  getUserRol(): string {
    return localStorage.getItem("userRol");
  }
  setUserRol(value: string): void {
    localStorage.setItem("userRol", value);
  }

  getListaClientes(): string {
    return localStorage.getItem("listaClientes");
  }
  setListaClientes(value: string): void {
    localStorage.setItem("listaClientes", value);
  }

  getClienteSeleccionado(): string {
    return localStorage.getItem("ClienteSeleccionado");
  }
  setClienteSeleccionado(value: string): void {
    localStorage.setItem("ClienteSeleccionado", value);
  }

  getClienteSeleccionadoId(): string {
    return localStorage.getItem("ClienteSeleccionadoId");
  }
  setClienteSeleccionadoId(value: string): void {
    localStorage.setItem("ClienteSeleccionadoId", value);
  }

  getClienteSeleccionadoTypeId(): string {
    return localStorage.getItem("ClienteSeleccionadoTypeId");
  }
  setClienteSeleccionadoTypeId(value: string): void {
    localStorage.setItem("ClienteSeleccionadoTypeId", value);
  }

  getViews(): string {
    return localStorage.getItem("views");
  }
  setViews(value: string): void {
    localStorage.setItem("views", value);
  }

  getListaCategorias(): string {
    return localStorage.getItem("listaCategorias");
  }
  setListaCategorias(value: string): void {
    localStorage.setItem("listaCategorias", value);
  }

  getPermissions(): string {
    return localStorage.getItem("permissions");
  }
  setPermissions(value: string): void {
    localStorage.setItem("permissions", value);
  }

  getShownTutorials(): string {
    return localStorage.getItem("ShownTutorials");
  }
  setShownTutorials(value: string): void {
    localStorage.setItem("ShownTutorials", value);
  }

  getSystemNotification(): string {
    return localStorage.getItem("SystemNotification");
  }
  setSystemNotification(value: string): void {
    localStorage.setItem("SystemNotification", value);
  }

  getSettingsSelectedTab(): string {
    return localStorage.getItem("settingsSelectedTab");
  }
  setSettingsSelectedTab(value: string): void {
    localStorage.setItem("settingsSelectedTab", value);
  }

  getQueryParams(): string {
    return localStorage.getItem("queryParams");
  }
  setQueryParams(value: string): void {
    localStorage.setItem("queryParams", value);
  }

  getIsReAuth(): string {
    return localStorage.getItem("isReAuth");
  }
  setIsReAuth(value: string): void {
    localStorage.setItem("isReAuth", value);
  }

  getSelectedBuildName(): string {
    return localStorage.getItem("selectedBuildName");
  }
  setSelectedBuildName(value: string): void {
    localStorage.setItem("selectedBuildName", value);
  }

  getRegularName(): string {
    return localStorage.getItem("regularName");
  }
  setRegularName(value: string): void {
    localStorage.setItem("regularName", value);
  }

  getVersion(): string {
    return localStorage.getItem("version");
  }
  setVersion(value: string): void {
    localStorage.setItem("version", value);
  }

  getPassword(): string {
    return localStorage.getItem("password");
  }
  setPassword(value: string): void {
    localStorage.setItem("password", value);
  }

  getMapLoadedViews(): string {
    return localStorage.getItem("mapLoadedViews");
  }
  setMapLoadedViews(value: string): void {
    localStorage.setItem("mapLoadedViews", value);
  }

  // ---------------imagenes -----------------------------
  getUrlList(): string {
    return localStorage.getItem("UrlList");
  }
  setUrlList(value: string): void {
    localStorage.setItem("UrlList", value);
  }

  getUrlMapList(): string {
    return localStorage.getItem("UrlMapList");
  }
  setUrlMapList(value: string): void {
    localStorage.setItem("UrlMapList", value);
  }

  getRedirectUrl(): string {
    return localStorage.getItem("redirectUrl");
  }
  setRedirectUrl(value: string): void {
    localStorage.setItem("redirectUrl", value);
  }
  clearRedirectUrl(): void {
    localStorage.removeItem("redirectUrl");
  }
}
